// Helpers de lecture des réponses API Platform.
// Une collection peut arriver sous forme de tableau JSON simple (Accept: application/json)
// ou en JSON-LD / Hydra ({ member | hydra:member, totalItems | hydra:totalItems }).

export const LD_HEADERS = { Accept: 'application/ld+json, application/json;q=0.9' }

export function unwrapCollection(data) {
  if (Array.isArray(data)) {
    return { items: data, totalItems: null }
  }
  if (data && typeof data === 'object') {
    const items = data.member || data['hydra:member'] || []
    const total = data.totalItems ?? data['hydra:totalItems']
    return { items, totalItems: Number.isFinite(Number(total)) ? Number(total) : null }
  }
  return { items: [], totalItems: null }
}

// Convertit une valeur décimale API ("555.0800") en nombre, ou null si absente / invalide.
export function toNumber(value) {
  if (value === null || value === undefined || value === '') return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

// Extrait l'identifiant numérique d'une IRI ("/api/customers/2430" -> 2430).
export function iriId(iri) {
  if (iri && typeof iri === 'object') return iri.id ?? iriId(iri['@id'])
  if (typeof iri !== 'string') return null
  const m = iri.match(/\/(\d+)$/)
  return m ? Number(m[1]) : null
}
